import GlobalState, {} from "../../../stores/GlobalState";
import Select, { components } from 'components/common/AppSelect'
import { observer } from 'mobx-react'

const SelectAttributeFilePage = observer(({
    langv,
    DropdownIndicator,
    optionscsw,
    customStyles,
    activeDataset,
    setOptionmetricsattr1,
    setOpenselect,
    masscheca,
    masscheca_order,
    checkmultiselect,
    openselect,
    textinselect,
    inputNameColumn,
    AddAttributesFile,
    blockRef,
    countword,
    countnowword,
    countwordLast,
    setOpenselectful2,
    setOpenselectful
    }) =>{
        return (
        <>
            <div className='select_line_segments'>
                <div className='select_line_segments_f'>
                    <span>{langv?.segmentation?.dataset}<star>*</star></span>
                    <Select 
                        components={{ DropdownIndicator }}
                        options={optionscsw} 
                        styles={customStyles} 
                        classNamePrefix='filter'
                        className='selectproduct new_filtr_datasets'
                          
                        placeholder={<div className='selectplace active'>{langv?.segmentation?.select_dataset}</div>}
                        onChange={(option) => setOptionmetricsattr1(option.value)}
                    />
                </div>
                <div className='select_line_segments_f f2select'>
                    <span>Column<star>*</star></span>
                    {
                        activeDataset!=''?
                        <>
                        <div className={openselect==false?'selectColumn block_select_create':'selectColumn block_select_create open'} tabIndex={0} onBlur={()=>setOpenselect(false)}>
                            <div className='title_select' onClick={()=>setOpenselect(true)}>
                                {
                                    textinselect==0?
                                    <div className='tlya' >{langv?.segmentation?.select_column}</div>
                                    :
                                    masscheca_order.map((n, id)=>
                                        n.check==true?
                                        <div className='minicheck'>
                                            <div >{n.title}</div>
                                            <svg style={{marginRight:"6px", marginTop:"2px"}} onClick={()=>checkmultiselect(n.id)} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12.1836 4.48633L5.21321 11.6567" stroke="#8E8E93" stroke-linecap="round"/>
                                                <path d="M5.11328 4.58398L12.2836 11.5544" stroke="#8E8E93" stroke-linecap="round"/>
                                            </svg>
                                        </div>
                                        :
                                        <></>
                                    )
                                }
                                
                            
                            </div>
                            {
                                openselect==false?
                                <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.80859 3.07617)" fill="#020203"/>
                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.80859 3.07617)" fill="black" fill-opacity="0.2"/>
                                    <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.80859 3.07617)" fill="black" fill-opacity="0.2"/>
                                    <path d="M1.19141 3.84615L7.53173 10L13.4991 3.84615" stroke="#020203"/>
                                    <path d="M1.19141 3.84615L7.53173 10L13.4991 3.84615" stroke="black" stroke-opacity="0.2"/>
                                    <path d="M1.19141 3.84615L7.53173 10L13.4991 3.84615" stroke="black" stroke-opacity="0.2"/>
                                </svg>
                                :
                                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="7.34706" cy="9.96229" r="1.53846" fill="#020203"/>
                                    <circle cx="7.34706" cy="9.96229" r="1.53846" fill="black" fill-opacity="0.2"/>
                                    <circle cx="7.34706" cy="9.96229" r="1.53846" fill="black" fill-opacity="0.2"/>
                                    <path d="M1.19141 7.65385L7.53173 1.5L13.4991 7.65385" stroke="#020203"/>
                                    <path d="M1.19141 7.65385L7.53173 1.5L13.4991 7.65385" stroke="black" stroke-opacity="0.2"/>
                                    <path d="M1.19141 7.65385L7.53173 1.5L13.4991 7.65385" stroke="black" stroke-opacity="0.2"/>
                                </svg>
                            }
                            
                            <div className={openselect==false?'selectColumn_block':'selectColumn_block open'}>
                                <div className='line_selectColumn'></div>
                                <div className='selectColumn_block_over'>
                                    
                                    {
                                        masscheca.map((n, id)=>
                                            <div className='checks_selectColumn' onClick={()=>checkmultiselect(n.id)}>
                                                {
                                                    n.check==false?
                                                    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.73679 1.33398H12.2606C12.7658 1.33398 13.2503 1.53466 13.6075 1.89188C13.9647 2.24909 14.1654 2.73357 14.1654 3.23875V12.7626C14.1654 13.2677 13.9647 13.7522 13.6075 14.1094C13.2503 14.4666 12.7658 14.6673 12.2606 14.6673H2.73679C2.23162 14.6673 1.74714 14.4666 1.38992 14.1094C1.03271 13.7522 0.832031 13.2677 0.832031 12.7626V3.23875C0.832031 2.73357 1.03271 2.24909 1.38992 1.89188C1.74714 1.53466 2.23162 1.33398 2.73679 1.33398Z" stroke="#C7C7CC" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    :
                                                    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M2.70833 0.5C1.99004 0.5 1.30116 0.785341 0.793252 1.29325C0.285341 1.80116 0 2.49004 0 3.20833V12.7917C0 13.51 0.285341 14.1988 0.793252 14.7067C1.30116 15.2147 1.99004 15.5 2.70833 15.5H12.2917C13.01 15.5 13.6988 15.2147 14.2067 14.7067C14.7147 14.1988 15 13.51 15 12.7917V3.20833C15 2.49004 14.7147 1.80116 14.2067 1.29325C13.6988 0.785341 13.01 0.5 12.2917 0.5H2.70833ZM1.25 3.20833C1.25 2.40333 1.90333 1.75 2.70833 1.75H12.2917C13.0967 1.75 13.75 2.40333 13.75 3.20833V12.7917C13.75 13.1784 13.5964 13.5494 13.3229 13.8229C13.0494 14.0964 12.6784 14.25 12.2917 14.25H2.70833C2.32156 14.25 1.95063 14.0964 1.67714 13.8229C1.40365 13.5494 1.25 13.1784 1.25 12.7917V3.20833ZM11.9 5.73333C11.9614 5.67611 12.0107 5.60711 12.0448 5.53045C12.079 5.45378 12.0973 5.37102 12.0988 5.2871C12.1003 5.20318 12.0849 5.11983 12.0534 5.042C12.022 4.96418 11.9752 4.89348 11.9159 4.83414C11.8565 4.77479 11.7858 4.728 11.708 4.69656C11.6302 4.66513 11.5468 4.64969 11.4629 4.65117C11.379 4.65265 11.2962 4.67102 11.2196 4.70518C11.1429 4.73934 11.0739 4.78859 11.0167 4.85L5.83083 10.03L3.98333 8.18333C3.86485 8.07293 3.70815 8.01283 3.54623 8.01569C3.38431 8.01854 3.22983 8.08414 3.11531 8.19865C3.0008 8.31316 2.93521 8.46765 2.93235 8.62956C2.9295 8.79148 2.9896 8.94819 3.1 9.06667L5.3875 11.355C5.50469 11.472 5.66354 11.5378 5.82917 11.5378C5.99479 11.5378 6.15365 11.472 6.27083 11.355L11.9 5.73333Z" fill="#34C759"/>
                                                    </svg>

                                                }
                                                
                                                <div className='check_selectColumn'>
                                                    {
                                                        n.title 
                                                    } 
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            
                        </div>


                        {/* <div className="columns_block_value select_line_segments select_line_segments2">
                            <span className="span_tlya">Value<star>*</star></span>
                            <div
                                className={"selectColumn block_select_create open"}
                                tabIndex={0}
                                onBlur={() => setOpenselectful2(id, id2, f)}
                            >
                                <div className="title_select_line" onClick={() => setOpenselectful(id, id2, f)}>
                                <div className="title_select" ref={blockRef}>
                                    {textinselect === 0 ? (
                                    <div className="tlya nontopmargin">{langv?.segmentation?.select_column}</div>
                                    ) : (
                                    <div className="tlya">
                                        {Array.isArray(v.value) ? (
                                        v.value
                                            .filter((n) => n.check)
                                            .slice(0, countword)
                                            .map((n, idx) => (
                                            <div key={idx} className="tag_value_cata_operator">
                                                {n.name}
                                                <svg
                                                style={{ marginRight: "6px", marginTop: "2px" }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    checkmultiselectmulty(idx, id, id2, n.name, f);
                                                }}
                                                width="17"
                                                height="16"
                                                viewBox="0 0 17 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                >
                                                <path d="M12.1836 4.48633L5.21321 11.6567" stroke="#8E8E93" strokeLinecap="round" />
                                                <path d="M5.11328 4.58398L12.2836 11.5544" stroke="#8E8E93" strokeLinecap="round" />
                                                </svg>
                                            </div>
                                            ))
                                        ) : (
                                        <div className="tag_value_cata_operator">{v.value}</div>
                                        )}
                                    </div>
                                    )}
                                </div>
                                <div className="tag_value_cata_operator_count_icon">
                                    {countword !== 0 && countword <= countnowword && countwordLast > 0 ? (
                                    <div className="tag_value_cata_operator_count">+{countwordLast}</div>
                                    ) : null}
                                    {v.select ? (
                                    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      
                                        <circle cx="7.34706" cy="9.96229" r="1.53846" fill="#020203" />
                                        <circle cx="7.34706" cy="9.96229" r="1.53846" fill="black" fillOpacity="0.2" />
                                        <circle cx="7.34706" cy="9.96229" r="1.53846" fill="black" fillOpacity="0.2" />
                                        <path d="M1.19141 7.65385L7.53173 1.5L13.4991 7.65385" stroke="#020203" />
                                        <path d="M1.19141 7.65385L7.53173 1.5L13.4991 7.65385" stroke="black" strokeOpacity="0.2" />
                                        <path d="M1.19141 7.65385L7.53173 1.5L13.4991 7.65385" stroke="black" strokeOpacity="0.2" />
                                    </svg>
                                    ) : (
                                    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        
                                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.80859 3.07617)" fill="#020203" />
                                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.80859 3.07617)" fill="black" fillOpacity="0.2" />
                                        <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.80859 3.07617)" fill="black" fillOpacity="0.2" />
                                        <path d="M1.19141 3.84615L7.53173 10L13.4991 3.84615" stroke="#020203" />
                                        <path d="M1.19141 3.84615L7.53173 10L13.4991 3.84615" stroke="black" strokeOpacity="0.2" />
                                        <path d="M1.19141 3.84615L7.53173 10L13.4991 3.84615" stroke="black" strokeOpacity="0.2" />
                                    </svg>
                                    )}
                                </div>
                                </div>
                                <div className={v.select ? "selectColumn_block2 open" : "selectColumn_block2"}>
                                <div className="line_selectColumn"></div>
                                <div className="selectColumn_block_over">
                                    {Array.isArray(v.value)
                                    ? v.value.map((o, iu) => (
                                        <div
                                            className="checks_selectColumn"
                                            key={iu}
                                            onClick={() => checkmultiselectmulty(iu, id, id2, o.name, f)}
                                        >
                                            {o.check === false ? (
                                            <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M2.73679 1.33398H12.2606C12.7658 1.33398 13.2503 1.53466 13.6075 1.89188C13.9647 2.24909 14.1654 2.73357 14.1654 3.23875V12.7626C14.1654 13.2677 13.9647 13.7522 13.6075 14.1094C13.2503 14.4666 12.7658 14.6673 12.2606 14.6673H2.73679C2.23162 14.6673 1.74714 14.4666 1.38992 14.1094C1.03271 13.7522 0.832031 13.2677 0.832031 12.7626V3.23875C0.832031 2.73357 1.03271 2.24909 1.38992 1.89188C1.74714 1.53466 2.23162 1.33398 2.73679 1.33398Z"
                                                stroke="#C7C7CC"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                />
                                            </svg>
                                            ) : (
                                            <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                d="M2.70833 0.5C1.99004 0.5 1.30116 0.785341 0.793252 1.29325C0.285341 1.80116 0 2.49004 0 3.20833V12.7917C0 13.51 0.285341 14.1988 0.793252 14.7067C1.30116 15.2147 1.99004 15.5 2.70833 15.5H12.2917C13.01 15.5 13.6988 15.2147 14.2067 14.7067C14.7147 14.1988 15 13.51 15 12.7917V3.20833C15 2.49004 14.7147 1.80116 14.2067 1.29325C13.6988 0.785341 13.01 0.5 12.2917 0.5H2.70833ZM1.25 3.20833C1.25 2.40333 1.90333 1.75 2.70833 1.75H12.2917C13.0967 1.75 13.75 2.40333 13.75 3.20833V12.7917C13.75 13.1784 13.5964 13.5494 13.3229 13.8229C13.0494 14.0964 12.6784 14.25 12.2917 14.25H2.70833C2.32156 14.25 1.95063 14.0964 1.67714 13.8229C1.40365 13.5494 1.25 13.1784 1.25 12.7917V3.20833ZM11.9 5.73333C11.9614 5.67611 12.0107 5.60711 12.0448 5.53045C12.079 5.45378 12.0973 5.37102 12.0988 5.2871C12.1003 5.20318 12.0849 5.11983 12.0534 5.042C12.022 4.96418 11.9752 4.89348 11.9159 4.83414C11.8565 4.77479 11.7858 4.728 11.708 4.69656C11.6302 4.66513 11.5468 4.64969 11.4629 4.65117C11.379 4.65265 11.2962 4.67102 11.2196 4.70518C11.1429 4.73934 11.0739 4.78859 11.0167 4.85L5.83083 10.03L3.98333 8.18333C3.86485 8.07293 3.70815 8.01283 3.54623 8.01569C3.38431 8.01854 3.22983 8.08414 3.11531 8.19865C3.0008 8.31316 2.93521 8.46765 2.93235 8.62956C2.9295 8.79148 2.9896 8.94819 3.1 9.06667L5.3875 11.355C5.50469 11.472 5.66354 11.5378 5.82917 11.5378C5.99479 11.5378 6.15365 11.472 6.27083 11.355L11.9 5.73333Z"
                                                fill="#34C759"
                                                />
                                            </svg>
                                            )}
                                            <div className="check_selectColumn">{o.name}</div>
                                        </div>
                                        ))
                                    : <div className="check_selectColumn">{v.value}</div>
                                    }
                                </div>
                                </div>
                            </div>
                        </div> */}

                        </>
                        :
                        <div className='selectColumn block_select_create block_select_create_nohover' tabIndex={0} >
                            <div className='title_select'>
                                {
                                    textinselect==0?
                                    <div className='tlya'>{langv?.segmentation?.select_column}</div>
                                    :
                                    <></>
                                }
                                
                            
                            </div>
                            
                            <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity="0.2">
                                <circle cx="1.53846" cy="1.53846" r="1.53846" transform="matrix(1 0 0 -1 5.30859 3.0769)" fill="#8E8E93"/>
                                <path d="M0.691406 3.84615L7.03173 10L12.9991 3.84615" stroke="#8E8E93"/>
                                </g>
                            </svg>
                            
                            
                            
                        </div>
                    }
                    
                </div>
            </div>
            <div className='select_line_segments_2'>
                {
                    textinselect==1||inputNameColumn!=''?
                    <div className='but_apply open' onClick={()=>AddAttributesFile()}>
                        {langv?.segmentation?.apply}
                    </div>
                    :
                    <div className='but_apply'>
                        {langv?.segmentation?.apply}
                    </div>
                }

                
            </div>
        </>
        )
    }
)

export default SelectAttributeFilePage;